<div class="tab-body mat-elevation-z1">
  <div class="section-header">
    <h2>
      <mat-icon>notification_important</mat-icon>
        Prisma Alerts
    </h2>
    <button mat-stroked-button type="button" (click)="refreshPrismaAlerts()" [disabled]="loading">
      <mat-icon>refresh</mat-icon>
      Refresh
    </button>
  </div>

  <p class="users-hint">
    Prisma alerts raised in GCP Cloud Monitoring. Review the suggested action and, if appropriate,
    suspend the associated user or dismiss the alert.
  </p>

  <div class="alerts-filter-row">
    <mat-form-field class="search-field" appearance="outline">
      <mat-label>Search alerts...</mat-label>
      <input matInput [(ngModel)]="alertsSearchTerm" (ngModelChange)="onAlertsFilterChange()" />
      <button mat-icon-button matSuffix type="button" aria-label="Clear alert search" *ngIf="alertsSearchTerm" (click)="alertsSearchTerm = ''; onAlertsFilterChange()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field class="alerts-assessment-field" appearance="outline">
      <mat-label>Assessment</mat-label>
      <mat-select [(ngModel)]="alertsAssessmentFilter" (ngModelChange)="onAlertsFilterChange()">
        <mat-option *ngFor="let option of alertAssessmentOptions" [value]="option.value">{{ option.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="alerts-age-field" appearance="outline">
      <mat-label>Age</mat-label>
      <mat-select [(ngModel)]="alertsAgeFilter" (ngModelChange)="onAlertsFilterChange()">
        <mat-option *ngFor="let option of alertAgeOptions" [value]="option.value">{{ option.label }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="loading-overlay" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <table class="admin-table alerts-table" *ngIf="getDisplayedAlerts().length > 0 && !loading">
    <thead>
      <tr>
        <th class="col-assessment">Assessment</th>
        <th class="col-resource">Resource</th>
        <th class="col-email">User</th>
        <th class="col-name">Alert</th>
        <th class="col-age">Age</th>
        <th class="col-suggestion">Suggestion</th>
        <th class="col-actions">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let alert of getPaginatedItems('alerts', getDisplayedAlerts()); trackBy: trackByAlertId">
        <td>
          <span class="alert-assessment-badge" [ngClass]="getAlertAssessmentClass(alert)">
            {{ getAlertAssessmentLabel(alert) }}
          </span>
          <span class="alert-closed-badge" *ngIf="alert.closed" matTooltip="This alert has been closed">CLOSED</span>
        </td>
        <td>{{ alert.resource || '—' }}</td>
        <td>{{ alert.userEmail || '—' }}</td>
        <td>{{ alert.name }}</td>
        <td [matTooltip]="(alert.startedAt | date:'medium') || ''">{{ getAlertAge(alert.startedAt) }}</td>
        <td class="alert-suggestion-cell">
          <ng-container *ngIf="hasAlertSuggestion(alert); else generateSuggestionCell">
            <span class="alert-suggestion-text" [matTooltip]="getAlertSuggestion(alert)">{{ getAlertSuggestion(alert) }}</span>
          </ng-container>
          <ng-template #generateSuggestionCell>
            <button mat-stroked-button type="button" class="alert-suggestion-btn"
              (click)="regenerateAlertSuggestion(alert)"
              [disabled]="isActionBusy(alertSuggestionActionKey(alert.id))"
              matTooltip="Generate an AI suggestion for this alert">
              <mat-spinner *ngIf="isActionBusy(alertSuggestionActionKey(alert.id))" diameter="14" class="btn-spinner"></mat-spinner>
              <mat-icon *ngIf="!isActionBusy(alertSuggestionActionKey(alert.id))">auto_awesome</mat-icon>
              Generate
            </button>
          </ng-template>
        </td>
        <td class="user-actions-cell">
          <div class="user-actions">
            <button mat-stroked-button color="warn" type="button"
              (click)="confirmSuspendFromAlert(alert)"
              [disabled]="isAlertBusy(alert) || !alert.userEmail"
              matTooltip="Suspend the associated user">
              <mat-spinner *ngIf="isActionBusy(alertSuspendActionKey(alert.id))" diameter="14" class="btn-spinner"></mat-spinner>
              <mat-icon *ngIf="!isActionBusy(alertSuspendActionKey(alert.id))">block</mat-icon>
              Suspend
            </button>
            <button mat-stroked-button type="button"
              (click)="closeAlert(alert)"
              [disabled]="isAlertBusy(alert) || alert.closed"
              [matTooltip]="alert.closed ? 'Alert already closed' : 'Close/triage this alert'">
              <mat-spinner *ngIf="isActionBusy(alertCloseActionKey(alert.id))" diameter="14" class="btn-spinner"></mat-spinner>
              <mat-icon *ngIf="!isActionBusy(alertCloseActionKey(alert.id))">check_circle</mat-icon>
              Close
            </button>
            <button mat-stroked-button color="warn" type="button"
              (click)="deleteAlert(alert)"
              [disabled]="isAlertBusy(alert) || !canDismissAlert(alert)"
              [matTooltip]="canDismissAlert(alert) ? 'Dismiss this alert' : 'Close the alert or suspend the user before dismissing'"
              class="delete-btn">
              <mat-spinner *ngIf="isActionBusy(alertDeleteActionKey(alert.id))" diameter="14" class="btn-spinner"></mat-spinner>
              <mat-icon *ngIf="!isActionBusy(alertDeleteActionKey(alert.id))">delete</mat-icon>
              Dismiss
            </button>
            <button mat-stroked-button type="button" class="user-info-icon-btn"
              (click)="openAlertInfo(alert)" matTooltip="More information">
              <mat-icon>info</mat-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="pagination-row" *ngIf="getDisplayedAlerts().length > 0 && !loading">
    <button mat-stroked-button type="button" (click)="goToPreviousPage('alerts')" [disabled]="getCurrentPage('alerts') === 1">Previous</button>
    <span>Page {{ getCurrentPage('alerts') }} of {{ getTotalPages('alerts', getDisplayedAlerts().length) }}</span>
    <button mat-stroked-button type="button" (click)="goToNextPage('alerts', getDisplayedAlerts().length)" [disabled]="getCurrentPage('alerts') >= getTotalPages('alerts', getDisplayedAlerts().length)">Next</button>
  </div>

  <div class="empty-state" *ngIf="getDisplayedAlerts().length === 0 && !loading">
    <mat-icon>notifications_off</mat-icon>
    <p>No Prisma alerts found.</p>
  </div>
</div>

<div class="modal-backdrop" *ngIf="selectedAlert">
  <div class="modal-card mat-elevation-z8 user-info-card">
    <div class="modal-header">
      <h3>
        <mat-icon>notification_important</mat-icon>
        {{ selectedAlert!.name }}
      </h3>
      <button mat-icon-button type="button" aria-label="Close alert details" (click)="closeAlertInfo()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="modal-body alert-info-body">
      <div class="user-info-status">
        <span class="alert-assessment-badge" [ngClass]="getAlertAssessmentClass(selectedAlert!)">
          {{ getAlertAssessmentLabel(selectedAlert!) }}
        </span>
        <span class="alert-severity-badge" [ngClass]="'alert-severity-' + (selectedAlert!.severity || 'unspecified').toLowerCase()">
          {{ selectedAlert!.severity || 'UNSPECIFIED' }}
        </span>
        <span class="user-status-badge user-status-active">{{ selectedAlert!.state }}</span>
      </div>

      <section class="alert-info-section">
        <h4 class="user-info-subtitle">Details</h4>
        <div class="user-history-grid">
          <div class="user-history-card">
            <div class="user-history-label"><mat-icon>dns</mat-icon> Resource</div>
            <div class="user-history-value">{{ selectedAlert!.resource || '—' }}</div>
          </div>
          <div class="user-history-card">
            <div class="user-history-label"><mat-icon>person</mat-icon> User</div>
            <div class="user-history-value">{{ selectedAlert!.userEmail || '—' }}</div>
          </div>
          <div class="user-history-card">
            <div class="user-history-label"><mat-icon>schedule</mat-icon> Raised</div>
            <div class="user-history-value">{{ selectedAlert!.startedAt ? (selectedAlert!.startedAt | date:'medium') : '—' }} <span *ngIf="selectedAlert!.startedAt">({{ getAlertAge(selectedAlert!.startedAt) }})</span></div>
          </div>
        </div>
      </section>

      <section class="alert-info-section">
        <h4 class="user-info-subtitle">Summary</h4>
        <p class="alert-summary-text">{{ selectedAlert!.summary }}</p>
      </section>

      <section class="alert-info-section">
        <h4 class="user-info-subtitle">
          <span>Suggested Action</span>
          <button mat-stroked-button type="button" class="alert-suggestion-btn"
            (click)="regenerateAlertSuggestion(selectedAlert!)"
            [disabled]="isActionBusy(alertSuggestionActionKey(selectedAlert!.id))"
            [matTooltip]="hasAlertSuggestion(selectedAlert!) ? 'Regenerate the AI suggestion' : 'Generate an AI suggestion'">
            <mat-spinner *ngIf="isActionBusy(alertSuggestionActionKey(selectedAlert!.id))" diameter="14" class="btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isActionBusy(alertSuggestionActionKey(selectedAlert!.id))">auto_awesome</mat-icon>
            {{ hasAlertSuggestion(selectedAlert!) ? 'Regenerate' : 'Generate' }}
          </button>
        </h4>
        <div class="alert-suggestion-panel">
          <p class="alert-summary-text">{{ getAlertSuggestion(selectedAlert!) }}</p>
        </div>
      </section>

      <section class="alert-info-section" *ngIf="getAlertLabelEntries(selectedAlert).length > 0">
        <h4 class="user-info-subtitle">Labels</h4>
        <ul class="user-history-list">
          <li *ngFor="let entry of getAlertLabelEntries(selectedAlert)">
            <code>{{ entry.key }}</code>: {{ entry.value }}
          </li>
        </ul>
      </section>

      <section class="alert-info-section" *ngIf="selectedAlert!.policyName">
        <h4 class="user-info-subtitle">Policy</h4>
        <p class="alert-policy-text"><code>{{ selectedAlert!.policyName }}</code></p>
      </section>
    </div>

    <div class="modal-footer user-info-footer">
      <div class="user-info-footer-actions">
        <button mat-stroked-button color="warn" type="button"
          (click)="confirmSuspendFromAlert(selectedAlert!)"
          [disabled]="isAlertBusy(selectedAlert!) || !selectedAlert!.userEmail">
          <mat-icon>block</mat-icon>
          Suspend User
        </button>
        <button mat-stroked-button type="button"
          (click)="closeAlert(selectedAlert!)"
          [disabled]="isAlertBusy(selectedAlert!) || selectedAlert!.closed"
          [matTooltip]="selectedAlert!.closed ? 'Alert already closed' : 'Close/triage this alert'">
          <mat-icon>check_circle</mat-icon>
          Close Alert
        </button>
        <button mat-stroked-button color="warn" type="button"
          (click)="deleteAlert(selectedAlert!)"
          [disabled]="isAlertBusy(selectedAlert!) || !canDismissAlert(selectedAlert!)"
          [matTooltip]="canDismissAlert(selectedAlert!) ? 'Dismiss this alert' : 'Close the alert or suspend the user before dismissing'"
          class="delete-btn">
          <mat-icon>delete</mat-icon>
          Dismiss Alert
        </button>
      </div>
      <div class="user-info-footer-primary">
        <button mat-stroked-button type="button" (click)="closeAlertInfo()">Done</button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="suspendAlertConfirm">
  <div class="modal-card mat-elevation-z8">
    <div class="modal-header">
      <button mat-icon-button type="button" aria-label="Close suspend confirmation" (click)="cancelSuspendFromAlert()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="modal-body">
      <p>
        Are you sure you want to <strong>suspend</strong>
        <code>{{ suspendAlertConfirm.userEmail }}</code> in response to alert
        <strong>{{ suspendAlertConfirm.name }}</strong>? Their account will be disabled
        and their environments deleted. The alert can then be dismissed.
      </p>
    </div>
    <div class="modal-footer">
      <button mat-stroked-button type="button" (click)="cancelSuspendFromAlert()">Cancel</button>
      <button mat-flat-button color="warn" type="button" (click)="suspendUserFromAlert()">
        <mat-icon>block</mat-icon> Suspend User
      </button>
    </div>
  </div>
</div>
